import React from 'react';
import styled from 'styled-components';
import LinkText from '../parts/LinkText';
import Text from '../parts/Text';

type FooterProps = {
  backgroundColor?: string;
}

const FooterStyle = styled.div<{ $backgroundColor?: string }>`
  display: flex;
  align-items: flex-end;
  background: ${props => props.$backgroundColor || 'white'};
  justify-content: space-between;
  padding: 30px;
  
  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

const FooterColumnLeft = styled.div`
  @media (max-width: 768px) {
    text-align: right;
    margin-bottom: 10px;
    width: 100%;
  }
`;

const FooterColumnRight = styled.div`
  text-align: right;

  ul {
    display: flex;
    column-gap: 15px;
    list-style: none;
    padding: 0;
  }
`;

const SiteNameStyle = styled.div`
  color: #383432;
  font-size: 60px;
  font-weight: bold;
  letter-spacing: 0.1em;
  line-height: 1;
`;

const SiteDescriptionStyle = styled.p`
  color: #383432;
  font-size: 18px;
  font-weight: bold;
  letter-spacing: 0.25em;
  margin: 0;
  padding-left: 4px;
`;

const Footer: React.FC<FooterProps> = ({ backgroundColor }) => {
  return (
    <FooterStyle $backgroundColor={backgroundColor}>
      <FooterColumnLeft>
        <SiteDescriptionStyle>あなたとカフェをつなぐ</SiteDescriptionStyle>
        <SiteNameStyle>Cafect</SiteNameStyle>
      </FooterColumnLeft>
      <FooterColumnRight>
        {/*<LinkButton href='/'>飲食店オーナー様はこちら</LinkButton>*/}
        <ul>
          <li>
            <LinkText href='https://alwaysblue.notion.site/367d37181f51432697b3db07ac52acf4?pvs=4' target='_blank' size={'14px'}>
              利用規約
            </LinkText>
          </li>
          <li>
            <LinkText href='https://alwaysblue.notion.site/13df50818afb4dd9b10806a72a6f7445?pvs=4' target='_blank' size={'14px'}>
              プライバシーポリシー
            </LinkText>
          </li>
          <li>
            <LinkText href='https://docs.google.com/forms/d/e/1FAIpQLSdteVScXpQ3byQLDIidT8k8SPjTsx2xge70Zt9X_LL_pV7W0Q/viewform?usp=sf_link' target='_blank' size={'14px'}>
              お問い合わせ
            </LinkText>
          </li>
        </ul>
        <Text>&copy; 2024 Cafect</Text>
      </FooterColumnRight>
    </FooterStyle>
  );
};

export default Footer;
